import {
    CONFIRMED_GET_SYMPTOM_MEDICINE_MAPPINGS,
    CONFIRMED_CREATE_SYMPTOM_MEDICINE_MAPPING_ACTION,
    CONFIRMED_DELETE_SYMPTOM_MEDICINE_MAPPING_ACTION,
    CONFIRMED_EDIT_SYMPTOM_MEDICINE_MAPPING_ACTION,
  } from "../actions/SymptomMedicineType";
  
  const initialState = {
    mappings: [],
  };
  
  export default function SymptomMedicineMappingReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_SYMPTOM_MEDICINE_MAPPINGS:
        return {
          ...state,
          mappings: action.payload,
        };
  
      case CONFIRMED_CREATE_SYMPTOM_MEDICINE_MAPPING_ACTION:
        return {
          ...state,
          mappings: [...state.mappings, action.payload],
        };
  
        case CONFIRMED_DELETE_SYMPTOM_MEDICINE_MAPPING_ACTION:
          return {
            ...state,
            mappings: state.mappings.filter(
              (m) => m.symptom_medicine_id !== action.payload.symptom_medicine_id
            ),
          };
        
  
      case CONFIRMED_EDIT_SYMPTOM_MEDICINE_MAPPING_ACTION:
        return {
          ...state,
          mappings: state.mappings.map((m) =>
            m.symptom_medicine_id === action.payload.symptom_medicine_id
              ? { ...m, ...action.payload }
              : m
          ),
        };
  
      default:
        return state;
    }
  }
  